import styled  from 'styled-components';
import { media } from 'src/ui/common/mixins/media';


export const StyledResponsiveContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const StyledHeadCell = styled.th`
  text-align: start;
  color: ${({ color, theme }) => color || theme.colors.gs200};
  padding: 5px 12px;
  white-space: nowrap;
`;

export const StyledRow = styled.tr`
`;

export const StyledCol = styled.td`
  color: ${({ color, theme }) => color || theme.colors.text};
  padding: 5px 12px;

  ${({ align }) => align && `text-align: ${align};`};
`;

export const StyledBody = styled.tbody`
`;

export const StyledHead = styled.thead`
`;

export const StyledTable = styled.table<{ stretch?: boolean }>`
  font-size: 14px;
  border-spacing: 0;
  
  ${({ stretch }) => stretch && 'width: 100%;'};

  ${media.sm`
    font-size: 16px;
  `}
`;

